import AccountInformationSection from './AccountInformationSection'
import $ from 'jquery'
import {MODE} from '../../panels/user/UserPanelContainer'

/*  CreateAccountInformationSection */
class CreateAccountInformationSection extends AccountInformationSection {}

CreateAccountInformationSection.prototype.init = function({
    lightBoxEl = null,
    userManagementData = null,
    currentTime = null,
    userId = null,
    accountSettings = null,
    changesCallback = () => {},
    validateCallback = () => {},
    checkUsernameErrorHandler = () => {},
    corporateSchedule = null,
    userGroupsEnabled = false,
    timeZoneGroupsEnabled = false,
    firstTTDate = null,
    firstLeaveRequestDate = null,
    editedUserIsSelf = false,
    handlerIfNoSuchUserAfterAjax = () => {},
    specificVersionDrawerConstructor = () => {},
    disableDuplicateUsernameCheck = false,
    disableEmptyUsernameCheck = false,
    scrollableContainerEl = null,
    showGroupRows = false,
    needValidation = true,
    releaseDateLabelEl,
    hireDateLabelEl,
}) {

    AccountInformationSection.prototype.init.call(this, {
        lightBoxEl,
        userManagementData,
        currentTime,
        userId,
        accountSettings,
        changesCallback,
        validateCallback,
        checkUsernameErrorHandler,
        corporateSchedule,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
        firstTTDate,
        firstLeaveRequestDate,
        editedUserIsSelf,
        handlerIfNoSuchUserAfterAjax,
        specificVersionDrawerConstructor,
        disableDuplicateUsernameCheck,
        disableEmptyUsernameCheck,
        scrollableContainerEl,
        showGroupRows,
        needValidation,
        hireDateLabelEl,
        mode: MODE.CREATE,
    })
    $(this.getElementBySubId("releaseDate")).hide()
    return this
}

export default CreateAccountInformationSection



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/CreateAccountInformationSection.js